<div class="table-container">
    <app-filters-bar class="filters-bar" [columnList]="model.displayedColumnsDefinitions" [filterHandler]="filterHandler"></app-filters-bar>
    <div class="result-container" (scroll)="onScrollDown($event)">
        <form [formGroup]="filtersForm" novalidate style="height: 100%">
            <table
                id="AdvancedTable"
                #AdvancedTable
                mat-table
                [dataSource]="dataSource"
                matSort
                class="result-table {{ className }}"
                infinite-scroll
                [infiniteScrollDistance]="scrollDistance"
                [infiniteScrollUpDistance]="scrollUpDistance"
                [infiniteScrollThrottle]="throttle"
                [scrollWindow]="false"
                [alwaysCallback]="true"
                multiTemplateDataRows="true">
                <!--- Note that these columns can be defined in any order.
        The actual rendered columns are set as a property on the row definition" -->

                <!-- Colonnes standards -->
                @for (column of model.displayedColumnsDefinitions; track column; let i = $index) {
                    <ng-container [matColumnDef]="column.columnName">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            mwlResizable
                            [style]="columnStyles[column.columnName]"
                            [ngClass]="{
                                NotFiltered: enumHelper.areEquals(FilterType, column.filterType, FilterType.None),
                                boolean: enumHelper.areEquals(FilterType, column.filterType, FilterType.Boolean),
                            }"
                            [style.min-width.%]="column.size"
                            [style.max-width.%]="column.size"
                            [style.width.%]="column.size">
                            <app-table-header-cell [column]="column"></app-table-header-cell>
                        </th>
                        <td
                            mat-cell
                            *matCellDef="let row"
                            [style.min-width.%]="column.size"
                            [style.max-width.%]="column.size"
                            [style.width.%]="column.size"
                            [ngClass]="{ boolean: enumHelper.areEquals(FilterType, column.filterType, FilterType.Boolean) }">
                            <app-table-cell [column]="column" [row]="row"></app-table-cell>
                        </td>
                    </ng-container>
                }

                <!-- Colonnes d'action -->
                @if (model.columnActionVisible) {
                    <ng-container [matColumnDef]="model.actionColumnDefinition.columnName" stickyEnd>
                        <th mat-header-cell *matHeaderCellDef aria-label="Actions" class="action-header" [style.min-width.%]="5" [style.max-width.%]="5" [style.width.%]="5">
                            @if (creationIcon === true) {
                                @if (readOnly === false) {
                                    <button mat-icon-button [disabled]="readOnly" (click)="onCreate()" aria-label="ajouter un element" class="accent-button">
                                        <mat-icon>add</mat-icon>
                                    </button>
                                }
                            } @else {
                                <div class="action-header-text">Actions</div>
                            }
                        </th>
                        <td
                            mat-cell
                            *matCellDef="let row; let index = dataIndex"
                            class="action-column action-cell"
                            [style.min-width.%]="5"
                            [style.max-width.%]="5"
                            [style.width.%]="5">
                            @if (!readOnly && row['nonEditable'] !== true) {
                                @if (contextualMenu) {
                                    <mat-icon id="menuIcon" (click)="menu($event, row); $event.preventDefault()">more_vert</mat-icon>
                                }
                                @if (sortEnabled) {
                                    <mat-icon id="sortIcon" (click)="displaySortDialog($event, row); $event.preventDefault()">swap_vert</mat-icon>
                                }
                            }
                        </td>
                    </ng-container>
                }

                <tr mat-header-row *matHeaderRowDef="model.displayedColumnNames; sticky: true"></tr>
                <tr
                    mat-row
                    *matRowDef="let row; columns: model.displayedColumnNames"
                    (click)="onSelected(row, $event)"
                    (dblclick)="onMouseDoubleClick(row, $event)"
                    (contextmenu)="menu($event, row); $event.preventDefault()"
                    class="element-row"></tr>
            </table>
        </form>
    </div>
    @if (contextualMenu) {
        <app-contextual-menu [items]="_menuItems" (menuChanged)="onMenuChanged($event)"></app-contextual-menu>
    }
</div>
